/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Participatedbefore1Inputs */

const en__field_participatedbefore1 = /** @type {(inputs: _Field_Participatedbefore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Did you participate in one of our workshops before?`)
};

const de__field_participatedbefore1 = /** @type {(inputs: _Field_Participatedbefore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haben Sie schonmal an einem Workshop des Methodenzentrums teilgenommen?`)
};

/**
* | output |
* | --- |
* | "Did you participate in one of our workshops before?" |
*
* @param {_Field_Participatedbefore1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_participatedbefore1 = /** @type {((inputs?: _Field_Participatedbefore1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Participatedbefore1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_participatedbefore1(inputs)
	return de__field_participatedbefore1(inputs)
});
export { _field_participatedbefore1 as "_field_participatedBefore" }